import { Check, Megaphone } from "lucide-react";
import { Link } from "react-router-dom";

export function Empty() {
  return (
      <Link to={`/suporte?new=true`} className="group w-full h-full flex items-center justify-center opacity-20 transition duration-700 hover:opacity-65" title="Abrir novo chamado de suporte">
        <div className="rounded-full relative w-[50%] aspect-square flex items-center justify-center bg-scale-500 transition duration-700 group-hover:w-[60%]">
          <Check className="absolute text-white w-[80%] h-[80%] opacity-100 transition duration-700 group-hover:opacity-0" />
          <Megaphone className="absolute text-white w-[80%] h-[80%] opacity-0 transition duration-700 group-hover:opacity-100" />
        </div>
      </Link>
  );
}
